<template>
  <div class="attr-list">
    <el-form>
      <el-form-item label="上传视频">
        <el-upload
          action
          :show-file-list="false"
          :http-request="uploadFile"
          :disabled="uploading"
          class="avatar-uploader"
        >
          <el-button :loading="uploading">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="循环播放">
        <el-switch
          v-model="curComponent.style.loop"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { uploadImage } from '@/api/user'
import { mapState } from 'vuex'
export default {
  components: { },
  data() {
    return {
      uploading: false
    }
  },
  computed: {
    curComponent() {
      return this.$store.state.compose.curComponent
    },
    ...mapState({
      projectItem: (state) => state.user.projectItem
    })
  },
  methods: {
    uploadFile(params) {
      const formData = new FormData()
      formData.append('file', params.file)
      formData.append('fileType', 'videoFile')
      formData.append('targetId', this.projectItem.projectId)
      params.onProgress({ percent: 0 })
      this.uploading = true
      const method = uploadImage

      method({
        data: formData,
        processCallBack: progressEvent => {
          params.onProgress({
            percent: (progressEvent.loaded / progressEvent.total) * 100
          })
        }
      }).then(res => {
        params.onSuccess(res.data)
        this.$set(this.curComponent.style, 'url', res.data.fileUrl)
      }).finally(() => {
        this.uploading = false
      })
    }
  }
}
</script>
